import { getAzureUserInformation } from '@/auth/azure/azureManager'
import { Roles } from '@/auth/azure/Roles'
import TicketsHistoricPage from '@/routes/tickets/historic/TicketsHistoricPage'
import { RoleRouteObject } from '@/types'
import { faEye, faTicket } from '@fortawesome/free-solid-svg-icons'
import { defer, LoaderFunction } from 'react-router-typesafe'

export const ticketsHistoricPageRouteLoader = (async () => {
  return defer({
    userInfo: await getAzureUserInformation(),
  })
}) satisfies LoaderFunction

const TicketsHistoricPageRoute = {
  path: 'historic',
  element: <TicketsHistoricPage />,
  loader: ticketsHistoricPageRouteLoader,
  allowedRoles: [Roles.Guest],
  handle: {
    crumb: () => ({
      label: 'Storico Ticket',
      icon: faEye,
    }),
  },
} as RoleRouteObject

export default TicketsHistoricPageRoute
